/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import React from "react";
import { Box, Tab, Tabs } from "@mui/material";

import { useStyles } from "./styles";
import RealmAdmin from "../realmAdmin/RealmAdmin";
import RealmGeneral from "../realmGeneral/RealmGeneral";
import { TabPanel } from "../../shared/TabPanel/TabPanel";
import RealmAdminDetails from "../realmAdmin/RealmAdminDetails";
import RealmEntitlements from "../realmEntitlement/RealmEntitlement";
import RealmIdps from "../realmIdps/RealmIdps";

const realmTabs = [
  {
    component: RealmGeneral,
    name: "General",
  },
  {
    component: RealmIdps,
    name: "Identity Providers",
  },
  // {
  //   component: RealmAdminDetails,
  //   name: "Realm Admin",
  // },
  {
    component: RealmEntitlements,
    name: "Entitlements",
  },
];

const RealmDetails = () => {
  const classes = useStyles();

  const [value, setValue] = React.useState(0);
  const handleChange = (_event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box className={classes.realmDetailContainer}>
      <Box className={classes.tabs}>
        <Tabs
          value={value}
          className={classes.tab}
          onChange={handleChange}
          aria-label="realm tabs"
        >
          {realmTabs.map((module, key) => (
            <Tab
              key={key}
              value={key}
              label={module.name}
              className={classes.tab}
            />
          ))}
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <RealmGeneral />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <RealmIdps />
      </TabPanel>
      {/* <TabPanel value={value} index={2}>
        <RealmAdminDetails />
      </TabPanel> */}
      <TabPanel value={value} index={2}>
        <RealmEntitlements />
      </TabPanel>
    </Box>
  );
};

export default RealmDetails;
